import { z } from 'zod';
/** POST /api/v2/data-sync/runs/:id/apply */ export const ApplyDataSyncRequestSchema = z.strictObject({
    selectedDifferenceIds: z.array(z.string())
});

//# sourceMappingURL=apply-data-sync.schema.js.map